
/* --------------- fade in anime --------------- */
window.addEventListener('DOMContentLoaded', function() {
  const fadeinElements = document.querySelectorAll('.fade-in');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  fadeinElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
			setTimeout(function() {
      	element.classList.add('scrollin');
			}, 500);
    }
  });
  const scrollElements = document.querySelectorAll('.scroll_anime');

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});

window.addEventListener('scroll', function() {
  const scrollElements = document.querySelectorAll('.scroll_anime');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {

	/* --------------- swiper --------------- */	
	const productSlide = new Swiper('.swiper', {
		loop: true,
		speed: 500,
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 0,
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		breakpoints: {
			750: {
				slidesPerView: 2.8,
				spaceBetween: 20,
				initialSlide: 11,
			}
		},
	});

});
